import { ApolloError, LazyQueryExecFunction } from '@apollo/client';
import {
  LobbiesGetQuery,
  LobbiesGetQueryVariables,
} from '../../libs/graphql/betzoneDirectusAPI/queries/__generated__/lobbies-get.query.generated';
import { Exact } from '../../libs/graphql/betzoneDirectusAPI/__generated_types__/types.generated';
import {
  GameSearchQuery,
  GameSearchQueryVariables,
} from '../../libs/graphql/betzoneDirectusAPI/queries/__generated__/game-search.query.generated';
import {
  GameGetBySlugQuery,
  GameGetBySlugQueryVariables,
} from '../../libs/graphql/betzoneDirectusAPI/queries/__generated__/game-get-by-slug.query.generated';
import {
  GamesGetByTagsQuery,
  GamesGetByTagsQueryVariables,
} from '../../libs/graphql/betzoneDirectusAPI/queries/__generated__/games-get-by-tags.query.generated';
import {
  GamesGetByCategoryQuery,
  GamesGetByCategoryQueryVariables,
} from '../../libs/graphql/betzoneDirectusAPI/queries/__generated__/games-get-by-category.query.generated';

export interface UseFetchGamesProps {
  tag?: string;
  slug?: string;
  count?: number;
  category?: string;
  language?: string;
  searchTerm?: string;
  gameId?: string | null;
  onSearchGameComplete?: (data: GameSearchQuery) => void;
  onGamesGetByTagsComplete?: (data: GameSearchQuery) => void;
  onLobbiesBySlugCompleted?: (data: LobbiesGetQuery) => void;
  onFetchGameBySlugComplete?: (data: GameGetBySlugQuery) => void;
  onGamesGetByCategoryComplete?: (data: GamesGetByCategoryQuery) => void;
}
export interface UseFetchGamesReturnType {
  fetchedLobbiesLoading: boolean;
  fetchedGameBySlugLoading: boolean;
  searchedGameQueryLoading: boolean;
  isFetchedGamesByTagsDataLoading: boolean;
  searchGameData: GameSearchQuery | undefined;
  isFetchedGamesByCategoryDataLoading: boolean;
  fetchedLobbiesError: ApolloError | undefined;
  searchedGameQueryError: ApolloError | undefined;
  fetchedLobbiesData: LobbiesGetQuery | undefined;
  fetchedGameBySlugError: ApolloError | undefined;
  fetchedGamesByTagsError: ApolloError | undefined;
  fetchedGamesByCategoryError: ApolloError | undefined;
  fetchedGameBySlugData: GameGetBySlugQuery | undefined;
  fetchedGamesByTagsData: GamesGetByTagsQuery | undefined;
  fetchedGamesByCategoryData: GamesGetByCategoryQuery | undefined;
  searchGame: LazyQueryExecFunction<GameSearchQuery, Exact<GameSearchQueryVariables>>;
  fetchLobbiesBySlug: LazyQueryExecFunction<LobbiesGetQuery, Exact<LobbiesGetQueryVariables>>;
  fetchGameBySlug: LazyQueryExecFunction<GameGetBySlugQuery, Exact<GameGetBySlugQueryVariables>>;
  fetchGamesByTags: LazyQueryExecFunction<GamesGetByTagsQuery, Exact<GamesGetByTagsQueryVariables>>;
  fetchGamesByCategory: LazyQueryExecFunction<GamesGetByCategoryQuery, Exact<GamesGetByCategoryQueryVariables>>;
}

export enum PromoTagCategory {
  BONUS = 'Bonus',
}
